import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';

@Injectable()
export class ExportService {
  constructor() {}

  exportToExcel(data: any[], fileName: string): void {
    // Convertir les données en CSV
    const headers = Object.keys(data[0]);
    const csvContent = [
      headers.join(','), // En-têtes
      ...data.map(row => headers.map(header => {
        const value = row[header];
        // Gérer les valeurs contenant des virgules ou des guillemets
        if (value === null || value === undefined) return '';
        const stringValue = String(value);
        return stringValue.includes(',') || stringValue.includes('"') 
          ? `"${stringValue.replace(/"/g, '""')}"` 
          : stringValue;
      }).join(','))
    ].join('\n');

    // Créer le blob et sauvegarder le fichier
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    FileSaver.saveAs(blob, `${fileName}.csv`);
  }
} 


// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/export.service.ts